import { AppAction } from "../root/AppAction";
import UserEvents from "./UserEvents";
import {
    AccessableEmail,
    AccessableEmailDomain,
    Group,
    User,
    UserData,
    UserList,
    UserSkill,
    UserLicense,
} from "./User";

export interface UserStore {
    isLoading: boolean;
    isFailedLogin: boolean;
    user?: UserData;
    userInfo?: User;
    userInfoList?: UserList[];
    skillList: UserSkill[];
    isUpdateUserInfo: boolean;
    isSuccessUpdateUserInfo: boolean;
    isFailedUpdateUserInfo: boolean;
    errorMessage: string;
    // updateUserList?: UpdateUserList[];
    groupList: Group[];
    domainList: AccessableEmailDomain[];
    emailList: AccessableEmail[];
    userLicense?: UserLicense;
    skillDuplicateError: string;
    isSessionTimeout: boolean;
}

const initialStore: UserStore = {
    isLoading: false,
    isFailedLogin: false,
    skillList: [],
    isUpdateUserInfo: false,
    isSuccessUpdateUserInfo: false,
    isFailedUpdateUserInfo: false,
    errorMessage: "",
    groupList: [],
    domainList: [],
    emailList: [],
    skillDuplicateError: "",
    isSessionTimeout: false,
};

// ログインユーザーのサムネイル更新（ユーザーリスト更新時）
function refreshLoginUserImage(userList: UserList[], userInfo: User | undefined) {
    if (!userInfo) return "";
    for (let index = 0; index < userList.length; index++) {
        const element = userList[index];
        if (element.id === String(userInfo.id)) {
            return element.imageUrl;
        }
    }
}

export default function user(state: UserStore = initialStore, action: AppAction) {
    switch (action.type) {
        case UserEvents.GetUserInfoListStarted:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.GetUserInfoListComplete:
            return {
                ...state,
                userInfoList: action.listItems,
                isLoading: false,
            };
        case UserEvents.GetGroupListStart:
            return {
                ...state,
            };

        case UserEvents.GetGroupListComplete:
            return {
                ...state,
                groupList: action.groupList,
            };
        case UserEvents.UpdateGroupListStart:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.UpdateGroupListComplete:
            return {
                ...state,
                groupList: action.groupList,
                isLoading: false,
            };

        // ユーザ情報更新
        case UserEvents.UpdateUserInfoStarted:
            return {
                ...state,
                isLoading: true,
                isUpdateUserInfo: true,
                isSuccessUpdateUserInfo: false,
                isFailedUpdateUserInfo: false,
            };
        case UserEvents.UpdateUserInfoComplete:
            return {
                ...state,
                userInfoList: action.listItems,
                userInfo: {
                    ...state.userInfo,
                    imageUrl: refreshLoginUserImage(action.listItems, state.userInfo),
                },
                isLoading: false,
                isUpdateUserInfo: false,
                isSuccessUpdateUserInfo: true,
                isFailedUpdateUserInfo: false,
            };
        case UserEvents.UpdateUserInfoFailed:
            return {
                ...state,
                isLoading: false,
                isUpdateUserInfo: false,
                isSuccessUpdateUserInfo: false,
                isFailedUpdateUserInfo: true,
            };

        case UserEvents.LoginStarted:
            return {
                ...state,
                isLoading: false,
                isFailedLogin: false,
            };
        case UserEvents.LoginComplete:
            return {
                ...state,
                user: action.user,
                userInfo: action.user,
                isLoading: false,
                isFailedLogin: false,
            };
        case UserEvents.LoginFailed:
            return {
                ...state,
                isLoading: false,
                isFailedLogin: true,
            };
        case UserEvents.SessionTimeout:
            return {
                ...state,
                isSessionTimeout: true,
            };
        case UserEvents.UpdateUserProfileImageStarted:
            return {
                ...state,
                isLoading: false,
            };
        case UserEvents.UpdateUserProfileImageComplete:
            return {
                ...state,
                userInfo: action.user,
                isLoading: false,
            };
        // 新規スキル作成
        case UserEvents.CreateNewSkillStarted:
            return {
                ...state,
                skillDuplicateError: "",
            };

        case UserEvents.CreateNewSkillCompleted:
            return {
                ...state,
                skillList: action.outputSkillList,
            };

        case UserEvents.CreateNewSkillFailed:
            return {
                ...state,
                skillList: action.outputSkillList,
                skillDuplicateError: action.message,
            };

        case UserEvents.ResetDuplicateSkillError:
            return {
                ...state,
                skillDuplicateError: "",
            };

        // ユーザスキル取得
        case UserEvents.GetSkillListStarted:
            return {
                ...state,
                isLoading: false,
            };

        case UserEvents.GetSkillListComplete:
            return {
                ...state,
                skillList: action.outputSkillList,
                isLoading: false,
            };
        // バッチの手動実行
        case UserEvents.StartSyncBatch:
            return {
                ...state,
                isLoading: true,
            };
        case UserEvents.StartSyncBatchComplete:
            return {
                ...state,
                errorMessage: "",
                isLoading: false,
            };
        case UserEvents.StartSyncBatchFailed:
            return {
                ...state,
                errorMessage: action.error,
                isLoading: false,
            };

        case UserEvents.GetAccessableEmailDomainListStart:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.GetAccessableEmailDomainListComplete:
            return {
                ...state,
                domainList: action.domainList,
                isLoading: false,
            };
        case UserEvents.UpdateAccessableEmailDomainListStart:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.UpdateAccessableEmailDomainListComplete:
            return {
                ...state,
                domainList: action.domainList,
                isLoading: false,
            };

        case UserEvents.GetAccessableEmailListStart:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.GetAccessableEmailListComplete:
            return {
                ...state,
                emailList: action.emailList,
                isLoading: false,
            };

        case UserEvents.UpdateAccessableEmailListStart:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.UpdateAccessableEmailListComplete:
            return {
                ...state,
                emailList: action.emailList,
                isLoading: false,
            };

        case UserEvents.GetUserLicenseStart:
            return {
                ...state,
                isLoading: true,
            };

        case UserEvents.GetUserLicenseComplete:
            return {
                ...state,
                isLoading: false,
                userLicense: action.userLicense,
            };

        default:
            return state;
    }
}
